import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useRef, useState } from 'react';
import Modal from '../../modal/Modal';
import { IoMdClose } from 'react-icons/io';
import Scanner from './Scanner';
import ScanArea from '../../../images/svg/receipt-scan-area.svg';
import ScanAreaMobile from '../../../images/svg/receipt-scan-area-mobile.svg';
import MediaQuery from 'react-responsive';
export var ReceiptScanModal = function ReceiptScanModal(props) {
  var _props$model = props.model,
      model = _props$model === void 0 ? {} : _props$model,
      show = props.show,
      hide = props.hide;
  var Headline = model.Headline,
      Copy = model.Copy,
      ScanHeadline = model.ScanHeadline,
      ScanCopy = model.ScanCopy;

  var handleDetected = function handleDetected(barcode) {
    hide();
    props.handleSubmitOrderNumber(barcode, 'inStore');
  };

  var scannerRef = useRef(null);

  var _useState = useState(100),
      _useState2 = _slicedToArray(_useState, 2),
      vh = _useState2[0],
      setVh = _useState2[1]; // Default value
  // Update viewport height to fix scroll on mobile devices


  useEffect(function () {
    var updateViewportHeight = function updateViewportHeight() {
      var newVh = window.innerHeight;

      if (window.innerWidth <= 1024) {
        newVh -= 148;
      } else {
        newVh -= 130;
      }

      setVh(newVh);
    };

    updateViewportHeight();
    window.addEventListener('resize', updateViewportHeight);
    return function () {
      window.removeEventListener('resize', updateViewportHeight);
    };
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Modal, {
    className: 'cb-receipt-scan',
    show: show,
    hide: hide,
    hideCloseButton: false,
    backdrop: false,
    size: 'lg'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'cb-receipt-scan__header'
  }, /*#__PURE__*/React.createElement("button", {
    className: "cb-receipt-scan__close",
    onClick: hide
  }, /*#__PURE__*/React.createElement(IoMdClose, null)), /*#__PURE__*/React.createElement("div", {
    className: 'cb-receipt-scan__header__headline'
  }, (Headline === null || Headline === void 0 ? void 0 : Headline.value) || ''), /*#__PURE__*/React.createElement("div", {
    className: 'cb-receipt-scan__header__copy'
  }, (Copy === null || Copy === void 0 ? void 0 : Copy.value) || '')), /*#__PURE__*/React.createElement("div", {
    style: {
      'height': "".concat(vh, "px")
    },
    className: 'cb-receipt-scan__container'
  }, /*#__PURE__*/React.createElement("div", {
    ref: scannerRef,
    className: 'cb-receipt-scan__body'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'cb-receipt-scan__scanner-container'
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      'height': "".concat(vh, "px")
    },
    className: 'cb-receipt-scan__scanner-area-overlay'
  }, /*#__PURE__*/React.createElement("div", {
    className: "cb-receipt-scan__scanner-area-overlay__grid-item"
  }), /*#__PURE__*/React.createElement("div", {
    className: "cb-receipt-scan__scanner-area-overlay__grid-item"
  }), /*#__PURE__*/React.createElement("div", {
    className: "cb-receipt-scan__scanner-area-overlay__grid-item"
  }), /*#__PURE__*/React.createElement("div", {
    className: "cb-receipt-scan__scanner-area-overlay__grid-item"
  }), /*#__PURE__*/React.createElement("div", {
    className: "cb-receipt-scan__scanner-area-overlay__grid-item cb-receipt-scan__scanner-area-overlay__grid-item--middle"
  }, /*#__PURE__*/React.createElement(MediaQuery, {
    maxWidth: 768
  }, /*#__PURE__*/React.createElement("img", {
    src: ScanAreaMobile,
    className: 'cb-receipt-scan__scanner-area-overlay__scan-area',
    alt: 'Scan area'
  })), /*#__PURE__*/React.createElement(MediaQuery, {
    minWidth: 769
  }, /*#__PURE__*/React.createElement("img", {
    src: ScanArea,
    className: 'cb-receipt-scan__scanner-area-overlay__scan-area',
    alt: 'Scan area'
  }))), /*#__PURE__*/React.createElement("div", {
    className: "cb-receipt-scan__scanner-area-overlay__grid-item"
  }), /*#__PURE__*/React.createElement("div", {
    className: "cb-receipt-scan__scanner-area-overlay__grid-item"
  }), /*#__PURE__*/React.createElement("div", {
    className: "cb-receipt-scan__scanner-area-overlay__grid-item"
  }), /*#__PURE__*/React.createElement("div", {
    className: "cb-receipt-scan__scanner-area-overlay__grid-item"
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      'height': "".concat(vh, "px")
    },
    className: 'cb-receipt-scan__scanner-area'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'cb-receipt-scan__scanner-area__container'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'cb-receipt-scan__scanner-area__headline'
  }, (ScanHeadline === null || ScanHeadline === void 0 ? void 0 : ScanHeadline.value) || ''), /*#__PURE__*/React.createElement("div", {
    className: 'cb-receipt-scan__scanner-area__copy'
  }, (ScanCopy === null || ScanCopy === void 0 ? void 0 : ScanCopy.value) || ''))), /*#__PURE__*/React.createElement("video", {
    style: {
      'height': "".concat(vh, "px")
    },
    className: 'cb-receipt-scan__scanner-container__video'
  }), /*#__PURE__*/React.createElement("canvas", {
    style: {
      'height': "".concat(vh, "px")
    },
    className: "drawingBuffer cb-receipt-scan__scanner-container__canvas"
  })), show && /*#__PURE__*/React.createElement(Scanner, {
    scannerRef: scannerRef,
    onDetected: handleDetected
  })))));
};